(function () {
  "use strict";

  angular.module("tm.supportChat")
    .controller("supportChatController", [
      "$scope",
      "$translate",
      "UserProvider",
      function (
        $scope,
        $translate,
        UserProvider
      ) {
        // fcWidget stub (SWPWEB-994)
        $scope.fcWidget = {
          init: () => {},
          destroy: () => {},
          isOpen: () => {},
          isInitialized: () => {},
          user: {
            setProperties: () => {}
          },
          open: () => {},
          close: () => {}
        };
        $scope.tooltipText = $translate.instant("views.nav.SupportChatDisabledTooltip");

        function init() {
          // ALK UserInfo structure
          //   data should be set by the product when the user logs into the product
          //   see @trimblemaps/webtools-common/javascript/AngularJS/alk-authentication/module
          $scope.userInfo = UserProvider.getUser();
          // fcWidget should be imported via <script> tag in each product's index.html
          // TODO pchen: use npm package because firewall blocks freshchat import <script>
          if (window.fcWidget) {
            $scope.fcWidget = window.fcWidget;
            $scope.fcWidget.init({
              // shared token for all apps and environments
              token: '797ed190-4ef3-4faa-81f8-367d7ba5e6dc',
              host: 'https://wchat.freshchat.com',
              // required, supposedly
              externalId: $scope.userInfo.userName,
              config: {
                headerProperty: {
                  hideChatButton: true
                }
              }
            });
            if ($scope.fcWidget.isInitialized()) {
              $scope.tooltipText = $translate.instant('views.nav.SupportChat');
            }
          }
        }

        $scope.toggleShowChat = () => {
          if (!$scope.fcWidget.isOpen()) {
            // always send up-to-date user info (SWPWEB-982)
            $scope.fcWidget.user.setProperties({
              firstName: $scope.userInfo.firstName,
              lastName: $scope.userInfo.lastName,
              email: $scope.userInfo.userName,
              account: $scope.userInfo.account
            }).then(() => {
              $scope.fcWidget.open();
            });
          } else {
            $scope.fcWidget.close();
          }
        };

        init();
      }
    ]);
})();



// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/tm-support-chat/supportChatController.js